export enum AdminPartnerSectionEnum {
  withMP = 'withMP',
  withoutMP = 'withoutMP',
}
